import React from "react";
import Link from "next/link";
import styles from "./search_hero.module.scss";

export const SearchHero = (props) => {
  const { keyword, pageData } = props;
  return (
    <section
      className={`${styles.section_search_hero} ${
        pageData?.length < 1 ? `${styles.min_height}` : ""
      }`}
    >
      <div className="container">
        <div className={styles.wrapper}>
          <h1 className={styles.heading}>
            {pageData?.length} Result showing for "{keyword}"
            {/* <span>
              Architecture in Australia - Colleges, Courses, Fees & Scope
            </span>
            <span className={`${styles.arc} arc`}></span> */}
          </h1>

          {pageData?.length < 1 && (
            <Link legacyBehavior href="https://myunisearch.com/">
              <a className="btn btn-secondary">Back Home</a>
            </Link>
          )}

          {/* <h2 className={styles.sub_heading}>
            41 Architecture Colleges in Australia
          </h2>
          <p className={styles.description}>
            International students who wish to study Architecture in the
            Australia will find that Architecture is a growing field with great
            career prospects both in the Australia and worldwide. There are
            numerous Architecture programs throughout the Australia for
            international students to choose from. Architecture in Australia is
            becoming a widely popular area of study because of the job
            opportunities it offers. Students who major in Architecture in
            Australia will find that they have a wide variety of career options
            open to them. Entrance requirements for Architecture in Australia
            programs vary college by college. If you are an international
            student considering a career in Architecture from Australia, be sure
            to speak with students and faculty to determine the pros and cons of
            each program you are considering. Although there are many
            Architecture programs throughout the Australia, a few stand out
            among the rest. The top colleges for Architecture in Australia are:-
            1. University Of Melbourne2. University Of
          </p> */}
        </div>
      </div>
    </section>
  );
};

export default SearchHero;
